import { gql } from '@apollo/client';


export const REMOVE_PERSON_FROM_INCIDENT = gql`
  mutation removePersonFromIncident($input: RemovePersonFromIncidentInput!) {
    removePersonFromIncident(input: $input) {
      errors
    }
  }
`


